import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApiConfig } from "@shared/models/redux";
import {
  DOCUMENT_TYPE_LOCATION_DOCUMENT,
  DOCUMENT_TYPE_SORT_COLUMN_NAME,
} from "@store/Entities/constants/documentTypeApi";
import { DocumentType } from "../models";

/**
 * Loads the filtered document type picklist for the Documents tab
 * (GET /documents/v1/DocumentTypes?documentLocation=document).
 *
 * Server-side filtering by entitledUserId is handled by RequestService (impersonation header).
 * State is reset by the root reducer on impersonation start/stop so a fresh fetch happens automatically.
 */
export const fetchDocumentsPageDocumentTypes = createAsyncThunk<DocumentType[], void, ThunkApiConfig>(
  "entities/fetchDocumentsPageDocumentTypes",
  async (_, { rejectWithValue, extra }) => {
    try {
      const response = await extra<DocumentType[]>("/documents/v1/DocumentTypes", {
        queryParams: {
          sortColumn: DOCUMENT_TYPE_SORT_COLUMN_NAME,
          documentLocation: DOCUMENT_TYPE_LOCATION_DOCUMENT,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue("Failed to load document types");
    }
  },
  {
    condition: (_, { getState }) => {
      const slice = getState().entities.documentsPageDocumentTypes;

      return !slice.loading && !slice.data;
    },
  }
);
